export enum WatchFace {
    classic = "classic",
    bigTimers = "bigTimers",
}
